import { DataTable } from "@/components/datatable/datatable"
import { DataTableSupabase } from "@/components/datatable/supadatatable"
import { Page, PageTitle } from "@/components/page"
import { usePage } from "@/components/page/hooks"
import { Button } from "@/components/ui/button"
import { usePermissions } from "@/lib/hooks/usePermissions"
import { Plus, Workflow } from "lucide-react"
import { useCallback } from "react"

export const playbooks = {
  title: "Playbooks",
  description: "Manage your conversation playbooks.",
  route: "/dev/playbooks",
  url: "/dev/playbooks",
  icon: Workflow,
  component,
  group: "dev",
  resource: "agents",
  action: "read",
} satisfies PageConfig

const columns: Columns<Table<"playbooks">> = {
  title: { header: "Title", size: 500 },
  model: { header: "Model", size: 300 },
  created_at: { header: "Created", cell: DataTable.cellRender.date, size: 166 },
}

function component() {

  const { team, navigate } = usePage()
  const { canCreate } = usePermissions()
  const filter = useCallback(q => q.eq("team", team?.id), [team])

  return <Page>
    <div className="h-full grid grid-rows-[auto_1fr] gap-4">
      <div className="flex">
        <PageTitle />
        <div className="grow"></div>
        {canCreate("agents") && <div>
          <Button className="rounded-lg" onClick={() => navigate('/dev/playbooks/new')}><Plus className="h-4 w-4" />New Playbook</Button>
        </div>}
      </div>
      <DataTableSupabase
        table="playbooks"
        columns={columns}
        showSelection
        onRowClick={"/dev/playbooks"}
        sort={["created_at", "desc"]}
        filter={filter}
        enableServerSideFiltering={true}
        searchableColumns={["title"]}
      />
    </div>
  </Page>

}
